import { combineReducers } from 'redux';

import flashMessageReducer from './flashMessage';
import dialogModalReducer from './dialogModal';
import chatReducer from './chat';

// AUTH
import { authentication } from '../../services/authentication';
import { curriculums } from '../../services/curriculums';
import { email } from '../../services/email';
import { eventLogs } from '../../services/eventLogs';
import { languages } from '../../services/languages';
import { lessons } from '../../services/lessons';
import { payment } from '../../services/payment';
import { permission } from '../../services/permission';
import { products } from '../../services/products';
import { productEvents } from '../../services/productEvents';
import { profile } from '../../services/profile';
import { response } from '../../services/response';
import { questionnaire } from '../../services/questionnaire';
import { seoContent } from '../../services/seoContent';
import { signedUrl } from '../../services/signedUrl';
import { channels } from '../../services/channels';
import { participants } from '../../services/participants';
import { users } from '../../services/users';
import { topic } from '../../services/topic';
import { subject } from '../../services/subject';

export default combineReducers({
  flashMessageReducer: flashMessageReducer as any,
  dialogModalReducer: dialogModalReducer as any,
  chatReducer: chatReducer as any,

  // AUTH
  [authentication.reducerPath]: authentication.reducer,
  [curriculums.reducerPath]: curriculums.reducer,
  [email.reducerPath]: email.reducer,
  [eventLogs.reducerPath]: eventLogs.reducer,
  [languages.reducerPath]: languages.reducer,
  [lessons.reducerPath]: lessons.reducer,
  [payment.reducerPath]: payment.reducer,
  [permission.reducerPath]: permission.reducer,
  [products.reducerPath]: products.reducer,
  [productEvents.reducerPath]: productEvents.reducer,
  [profile.reducerPath]: profile.reducer,
  [response.reducerPath]: response.reducer,
  [questionnaire.reducerPath]: questionnaire.reducer,
  [seoContent.reducerPath]: seoContent.reducer,
  [signedUrl.reducerPath]: signedUrl.reducer,
  [channels.reducerPath]: channels.reducer,
  [participants.reducerPath]: participants.reducer,
  [users.reducerPath]: users.reducer,
  [topic.reducerPath]: topic.reducer,
  [subject.reducerPath]: subject.reducer,
});
